"use strict";

require("core-js/modules/es.array.iterator");

var baseExtend = require("../.internal/baseExtend.js");

const setter = (obj, [k, v]) => (obj[k] = v, obj);

module.exports = extend;

function extend(obj, ...objs) {
  return baseExtend(setter, obj, objs);
}